module.exports = __webpack_public_path__ + "img/preloader.b6794ad6.png";